import React, { memo } from 'react';
import {
  Disclaimer,
  Footer,
  useMobileAppDownloadLinks,
  useGetAppInitDetails,
} from '@highmark-web/highmark-common';
import { useFooterLinks } from 'hooks/use-footer-links';
import { Image } from '@leagueplatform/genesis-core';
import { APP_STORE_PROD_URL, PLAY_STORE_PROD_URL } from 'common/constants';

export const BCBSWyFooter = memo(() => {
  const { footerLinks } = useFooterLinks();
  const { mobileAppDownloadLinks } = useMobileAppDownloadLinks(
    APP_STORE_PROD_URL,
    PLAY_STORE_PROD_URL,
  );
  const { brandingInfo, appMessaging } = useGetAppInitDetails();

  return (
    <Footer
      branding={
        <Image
          src={brandingInfo?.brandingLogo}
          alt="BCBSWyoming Branding"
          css={{
            marginBottom: '50px',
            width: '170px',
          }}
        />
      }
      disclaimer={<Disclaimer disclaimer={appMessaging?.disclaimer || ''} />}
      footerLinks={footerLinks}
      footerAppDownloadAssets={mobileAppDownloadLinks}
    />
  );
});
